import PropTypes from "prop-types";
import React from "react";

import { AnswerBubble } from "../AnswerBubble";
import { createClassNameString } from "../utils";
import { Text } from "../Text";
import { TextColors, TextTypes } from "../constants";

import "./styles.scss";

export const SingleQuestionAnswerBubble = ({
  answerIds,
  className,
  questionSetCategory,
  questionSetOptions,
  style,
}) => {
  const classNamesArray = ["apti-CL apti-SingleQuestionAnswerBubble", className];

  return (
    <div className={createClassNameString(classNamesArray)} style={style}>
      <div className="pb-3">
        <Text color={TextColors.purple} type={TextTypes.label}>
          {questionSetCategory}
        </Text>
      </div>

      {questionSetOptions.map((questionSetOption, optionIndex) => {
        const filled = answerIds.includes(optionIndex);

        return (
          <div
            className="d-flex pb-1"
            key={`apti-SingleQuestionAnswerBubble-${questionSetCategory}-${optionIndex}`}
          >
            <div className="pr-2">
              <AnswerBubble filled={filled} />
            </div>
            <Text>{questionSetOption}</Text>
          </div>
        );
      })}
    </div>
  );
};

SingleQuestionAnswerBubble.propTypes = {
  answerIds: PropTypes.array,
  className: PropTypes.string,
  questionSetOptions: PropTypes.array,
  questionText: PropTypes.string,
  style: PropTypes.object,
};

SingleQuestionAnswerBubble.defaultProps = {
  answerIds: [],
  className: undefined,
  questionSetOptions: [],
  questionText: undefined,
  style: {},
};
